<div class="season-pass-form-page">
    <div class="btn-back-detail" (click)="cancel()">
        <i class="fal fa-arrow-left"></i>
        <span>Ver abonados de esta temporada</span>
    </div>

    <div *ngIf="!loaded" class="loading-container">
        <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
    </div>

    <!-- Cabecera de detalle: quién es el abonado y qué abono es -->
    <div class="detail-hero" *ngIf="loaded && isEdit && pass">
        <div class="hero-main">
            <div class="hero-avatar">{{ userInitials }}</div>
            <div class="hero-identity">
                <h1 class="hero-name">{{ readonlyUser?.name }}</h1>
                <div class="hero-contact">
                    <span *ngIf="readonlyUser?.nif"><i class="fal fa-id-badge"></i> {{ readonlyUser.nif }}</span>
                    <!-- La fecha de nacimiento es la que determina la categoría del
                         abono, así que se muestra junto al resto de datos del abonado. -->
                    <span *ngIf="readonlyUser?.birthday"><i class="fal fa-cake-candles"></i> {{ readonlyUser.birthday | date: 'dd/MM/yyyy' }}</span>
                    <span *ngIf="readonlyUser?.email"><i class="fal fa-envelope"></i> {{ readonlyUser.email }}</span>
                    <span *ngIf="readonlyUser?.phone"><i class="fal fa-phone"></i> {{ readonlyUser.phone }}</span>
                </div>
            </div>
            <div class="hero-actions">
                <span class="status-badge" [ngClass]="statusBadgeClass">
                    <i class="fa-solid" [ngClass]="statusIcon"></i>
                    {{ pass.status?.name || 'Sin estado' }}
                </span>
                <!-- Abono aún sin cobrar: acceso directo a la taquilla. Sin
                     butaca no hay importe que cobrar, así que se explica. -->
                <button type="button" class="btn-charge" *ngIf="canCharge"
                    [disabled]="!canChargeNow"
                    [title]="canChargeNow ? '' : 'Asígnale una butaca antes de cobrarle'"
                    (click)="goToCheckout()">
                    <i class="fal fa-cash-register"></i> Cobrar abono
                </button>
            </div>
        </div>

        <div class="hero-meta">
            <div class="meta-item">
                <span class="meta-label">Temporada</span>
                <p class="meta-value">{{ editSeason?.name || '—' }}</p>
            </div>
            <div class="meta-item">
                <span class="meta-label">Nº de abonado</span>
                <p class="meta-value">{{ pass.member_number || '—' }}</p>
            </div>
            <div class="meta-item">
                <span class="meta-label">Categoría</span>
                <p class="meta-value">{{ pass.category?.name || '—' }}</p>
            </div>
            <!-- "Ubicación": el valor lleva el nivel delante de la fila y la
                 butaca, que sin él no identifican ningún sitio del recinto. -->
            <div class="meta-item">
                <span class="meta-label">Ubicación</span>
                <p class="meta-value">{{ seatDisplay || '—' }}</p>
            </div>
        </div>
    </div>

    <form *ngIf="loaded" [formGroup]="form" (ngSubmit)="save()" class="form-layout">
        <!-- Left column: Form -->
        <div class="form-column">

            <!-- Temporada: selector en alta -->
            <div class="form-card" *ngIf="!isEdit">
                <div class="card-header">
                    <i class="fal fa-calendar-range card-icon"></i>
                    <div>
                        <h2>Temporada</h2>
                        <p class="card-subtitle">Temporada a la que pertenece el abono</p>
                    </div>
                </div>
                <div class="form-field">
                    <label class="field-label">TEMPORADA</label>
                    <select formControlName="id_season" class="native-select">
                        <option [ngValue]="null" disabled>Selecciona una temporada</option>
                        <option *ngFor="let s of seasons" [ngValue]="s.id">
                            {{ s.name }}{{ s.active ? '' : ' (inactiva)' }}
                        </option>
                    </select>
                    <span class="field-hint" *ngIf="seasons.length === 0">
                        <i class="fal fa-info-circle"></i> No hay temporadas creadas. Crea una en la pestaña «Temporadas» antes de dar de alta abonos
                    </span>
                </div>
            </div>

            <!-- Categoría: en el alta siempre, y en edición mientras el abono no
                 tenga un cobro pagado (ver canEditCategory). El nº de socio no
                 se pide: lo asigna automáticamente el backend al crear el abono. -->
            <div class="form-card" *ngIf="!isEdit || canEditCategory">
                <div class="card-header">
                    <i class="fal fa-tags card-icon"></i>
                    <div>
                        <h2>Categoría del abono</h2>
                        <p class="card-subtitle">Determina el importe que se cobrará después</p>
                    </div>
                </div>
                <div class="form-field">
                    <label class="field-label">CATEGORÍA</label>
                    <select formControlName="id_category" class="native-select">
                        <option [ngValue]="null" disabled>Selecciona una categoría</option>
                        <option *ngFor="let c of categories" [ngValue]="+c.id">{{ c.name }}</option>
                    </select>
                    <span class="field-hint" *ngIf="categories.length === 0">
                        <i class="fal fa-info-circle"></i> No hay categorías de abono configuradas
                    </span>
                </div>
                <span class="field-hint" *ngIf="!isEdit">
                    <i class="fal fa-info-circle"></i> El nº de socio se asigna automáticamente al guardar el abono
                </span>
                <span class="field-hint" *ngIf="isEdit">
                    <i class="fal fa-info-circle"></i> Aún no se le ha cobrado nada, así que el cambio se aplicará al importe que se le cobre
                </span>
            </div>

            <!-- Usuario: solo en alta -->
            <div class="form-card" *ngIf="!isEdit">
                <div class="card-header">
                    <i class="fal fa-user card-icon"></i>
                    <div>
                        <h2>Usuario abonado</h2>
                        <p class="card-subtitle">Busca un usuario ya registrado o crea uno nuevo</p>
                    </div>
                </div>

                <div class="person-mode-toggle">
                    <button type="button" class="toggle-btn" [class.selected]="personMode === 'existing'"
                        (click)="setPersonMode('existing')">
                        <i class="fal fa-magnifying-glass"></i> Usuario existente
                    </button>
                    <button type="button" class="toggle-btn" [class.selected]="personMode === 'new'"
                        (click)="setPersonMode('new')">
                        <i class="fal fa-user-plus"></i> Usuario nuevo
                    </button>
                </div>

                <!-- Modo A: buscar usuario existente -->
                <div class="form-field" *ngIf="personMode === 'existing'" style="margin-top: 16px;">
                    <label class="field-label">BUSCAR USUARIO REGISTRADO</label>
                    <input type="text" placeholder="correo@ejemplo.com"
                        name="season-pass-user-search" autocomplete="new-password" autocorrect="off"
                        autocapitalize="off" spellcheck="false" data-lpignore="true" data-form-type="other"
                        [(ngModel)]="userSearchTerm" [ngModelOptions]="{standalone: true}"
                        [matAutocomplete]="userAuto" (input)="onUserSearchInput()">
                    <mat-autocomplete #userAuto="matAutocomplete" [displayWith]="displayUserFn" (optionSelected)="onUserSelected($event)">
                        <mat-option *ngIf="searchingUsers" disabled>Buscando...</mat-option>
                        <mat-option *ngFor="let u of userSearchResults" [value]="u">
                            {{u.name}} <span class="option-hint">{{u.nif}} · {{u.email}}</span>
                        </mat-option>
                    </mat-autocomplete>
                    <span class="field-hint" *ngIf="!selectedUser">
                        <i class="fal fa-info-circle"></i> Introduce el correo electrónico completo del usuario
                    </span>
                    <span class="field-hint" *ngIf="selectedUser">
                        <i class="fal fa-check-circle"></i> {{selectedUser.email}}{{selectedUser.phone ? ' · ' + selectedUser.phone : ''}}
                    </span>
                </div>

                <!-- Usuario existente sin NIF: se le pide obligatoriamente -->
                <div class="form-field" *ngIf="personMode === 'existing' && existingUserNeedsNif" style="margin-top: 16px;">
                    <label class="field-label">NIF / DOCUMENTO</label>
                    <input type="text" formControlName="nif" placeholder="Ej: 12345678A">
                    <span class="field-hint">
                        <i class="fal fa-triangle-exclamation"></i> Este usuario no tiene documento guardado. Introdúcelo para completar su ficha; se añadirá a su cuenta
                    </span>
                </div>

                <!-- Ídem con la fecha de nacimiento: es lo que permitirá actualizarle
                     la categoría por edad en las renovaciones de próximas temporadas -->
                <div class="form-field" *ngIf="personMode === 'existing' && existingUserNeedsBirthday" style="margin-top: 16px;">
                    <label class="field-label">FECHA DE NACIMIENTO</label>
                    <app-date-field formControlName="birthday" [max]="maxBirthDate"></app-date-field>
                    <span class="field-hint">
                        <i class="fal fa-triangle-exclamation"></i> Este usuario no tiene fecha de nacimiento guardada. Es necesaria para actualizar su categoría de abono en próximas temporadas; se añadirá a su cuenta
                    </span>
                </div>

                <!-- Modo B: crear usuario nuevo -->
                <ng-container *ngIf="personMode === 'new'">
                    <div class="form-grid-2" style="margin-top: 16px;">
                        <div class="form-field">
                            <label class="field-label">NOMBRE COMPLETO</label>
                            <input type="text" formControlName="name" placeholder="Nombre y apellidos">
                        </div>
                        <div class="form-field">
                            <label class="field-label">NIF / DOCUMENTO</label>
                            <input type="text" formControlName="nif" placeholder="Ej: 12345678A">
                        </div>
                    </div>
                    <div class="form-grid-2" style="margin-top: 16px;">
                        <div class="form-field">
                            <label class="field-label">EMAIL</label>
                            <input type="text" formControlName="email" placeholder="correo@ejemplo.com">
                        </div>
                        <div class="form-field">
                            <label class="field-label">TELÉFONO</label>
                            <input type="text" formControlName="phone" placeholder="Opcional">
                        </div>
                    </div>
                    <div class="form-grid-2" style="margin-top: 16px;">
                        <div class="form-field">
                            <label class="field-label">FECHA DE NACIMIENTO</label>
                            <app-date-field formControlName="birthday" [max]="maxBirthDate"></app-date-field>
                            <span class="field-hint">
                                <i class="fal fa-info-circle"></i> Necesaria para actualizar su categoría de abono en próximas temporadas
                            </span>
                        </div>
                    </div>
                    <span class="field-hint">
                        <i class="fal fa-info-circle"></i> Si ya existe un usuario con ese NIF, se asociará el abono a él en vez de crear un duplicado
                    </span>
                </ng-container>
            </div>

            <!-- Butaca: obligatoria, porque el tipo de abono (y su precio)
                 depende del nivel de la butaca del abonado. -->
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-chair card-icon"></i>
                    <div>
                        <h2>Butaca asignada</h2>
                        <p class="card-subtitle">El abono que paga depende de su categoría y del nivel de esta butaca</p>
                    </div>
                </div>

                <!-- Espacio: seleccionable en alta; en edición es fijo (el del abono). -->
                <div class="form-field" *ngIf="!isEdit">
                    <label class="field-label">ESPACIO</label>
                    <select formControlName="id_space" class="native-select">
                        <option [ngValue]="null">Selecciona un espacio</option>
                        <option *ngFor="let sp of spaces" [ngValue]="sp.id">{{ sp.name }}</option>
                    </select>
                </div>

                <div *ngIf="form.value.id_space">
                    <!-- El mapa es la única vía de asignar butaca: así el nivel (y con
                         él el abono que se cobra) siempre sale de una butaca real.
                         Cobrado el abono, la butaca es firme y no se ofrece cambiarla. -->
                    <button type="button" class="btn-seat-map" *ngIf="canEditSeat" (click)="openSeatMap()"
                        [disabled]="seatMapLoading">
                        <i class="fal" [ngClass]="seatMapLoading ? 'fa-spinner-third fa-spin' : 'fa-map-location-dot'"></i>
                        {{ seatSelection ? 'Cambiar butaca en el mapa' : 'Seleccionar butaca en el mapa' }}
                    </button>

                    <!-- Resumen de la butaca elegida -->
                    <div class="seat-selected-summary" *ngIf="seatSelection">
                        <i class="fal fa-chair"></i>
                        <span class="seat-selected-text">
                            <ng-container *ngIf="seatSelection.levelName">{{ seatSelection.levelName }} · </ng-container>
                            <ng-container *ngIf="seatSelection.sectionName">{{ seatSelection.sectionName }} · </ng-container>
                            <ng-container *ngIf="seatSelection.row != null">Fila {{ seatSelection.row }} · </ng-container>
                            Butaca {{ seatSelection.seat }}
                        </span>
                    </div>

                    <!-- Abono ya cobrado: la butaca no se toca desde aquí, porque las
                         reservas de sus eventos ya publicados se generaron con ella. -->
                    <p class="field-hint" *ngIf="!canEditSeat">
                        <i class="fal fa-lock"></i>
                        Esta butaca ya no se puede cambiar: el abono ha dejado de estar pendiente y las
                        entradas de sus eventos ya publicados se generaron con ella. Para moverlo de sitio
                        hay que anular el abono y darlo de alta de nuevo en la butaca nueva.
                    </p>

                    <!-- Butaca de otro nivel: el tipo de abono pasa a ser el de
                         ese nivel. La diferencia de precio es informativa. -->
                    <div class="level-change" *ngIf="levelChanged">
                        <div class="level-change-header">
                            <i class="fal fa-arrow-right-arrow-left"></i>
                            <span>
                                Butaca de otro nivel<ng-container *ngIf="newLevelName">: {{ newLevelName }}</ng-container>
                            </span>
                        </div>

                        <p class="level-change-current" *ngIf="currentProduct">
                            Ahora tiene contratado <strong>{{ currentProduct.name }}</strong>
                            ({{ currentProduct.price | number:'1.2-2' }} €)
                        </p>

                        <div class="levels-loading" *ngIf="levelChangeLoading">
                            <i class="fal fa-spinner-third fa-spin"></i> Cargando los abonos de ese nivel...
                        </div>

                        <ng-container *ngIf="!levelChangeLoading">
                            <p class="field-hint" *ngIf="levelChangeProducts.length === 0">
                                <i class="fal fa-triangle-exclamation"></i>
                                Ese nivel no tiene ningún abono configurado para la categoría de este
                                abonado. Configúralo en la ficha de la temporada.
                            </p>

                            <ng-container *ngIf="levelChangeProducts.length > 0">
                                <span class="field-label">ESTE ABONO PASA A</span>
                                <div class="level-change-option" *ngFor="let p of levelChangeProducts"
                                    [class.selected]="selectedNewProductId === p.id"
                                    (click)="selectNewProduct(p.id)">
                                    <i class="fal" [ngClass]="selectedNewProductId === p.id ? 'fa-circle-dot' : 'fa-circle'"></i>
                                    <span class="level-change-option-name">{{ p.name }}</span>
                                    <span class="level-change-option-price">{{ p.price | number:'1.2-2' }} €</span>
                                </div>

                                <p class="field-hint" *ngIf="priceDifference !== null">
                                    <i class="fal fa-info-circle"></i>
                                    Diferencia de {{ priceDifference | number:'1.2-2' }} € respecto a lo que
                                    tiene contratado. No se cobra ni se devuelve nada automáticamente.
                                </p>

                                <p class="field-hint" *ngIf="!hasPaidRenewal">
                                    <i class="fal fa-info-circle"></i>
                                    Este abono todavía no está cobrado: al pagar verá directamente los
                                    abonos del nivel nuevo. Si tenía un pago iniciado, se cancelará.
                                </p>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>

                <p class="field-hint" *ngIf="!isEdit && form.errors?.['seatRequired']">
                    <i class="fal fa-info-circle"></i>
                    La butaca es obligatoria: el abono que paga el abonado depende del nivel en el que esté.
                </p>
            </div>

            <!-- Datos del abono -->
            <div class="form-card">
                <div class="card-header">
                    <i class="fal fa-id-card card-icon"></i>
                    <div>
                        <h2>Datos del abono</h2>
                        <p class="card-subtitle">Fecha de alta y observaciones</p>
                    </div>
                </div>

                <div class="form-field">
                    <label class="field-label">FECHA DE ALTA</label>
                    <app-date-field formControlName="registered_at"></app-date-field>
                    <span class="field-hint" *ngIf="!isEdit"><i class="fal fa-info-circle"></i> Si se deja vacía, se usará la fecha de hoy</span>
                </div>

                <div class="form-field" style="margin-top: 16px;">
                    <label class="field-label">OBSERVACIONES</label>
                    <textarea formControlName="notes" rows="3" placeholder="Notas internas opcionales"></textarea>
                </div>

                <span class="field-hint" *ngIf="isEdit" style="margin-top: 16px;">
                    <i class="fal fa-lock"></i> La temporada y los datos personales no se editan aquí: la temporada de un abono no puede cambiarse y los datos del usuario se modifican desde su ficha
                </span>
            </div>
        </div>

        <!-- Right column: Actions -->
        <div class="preview-column">
            <div class="form-card actions-card">
                <div class="form-actions">
                    <button type="submit" class="btn-save" [disabled]="form.invalid || saving">
                        <i class="fal" [ngClass]="saving ? 'fa-spinner-third fa-spin' : (isEdit ? 'fa-floppy-disk' : 'fa-arrow-right')"></i>
                        {{ saving ? 'Guardando...' : (isEdit ? 'Guardar cambios' : 'Crear y continuar al cobro') }}
                    </button>
                    <button type="button" class="btn-cancel" (click)="cancel()">
                        Cancelar
                    </button>
                </div>

                <div class="missing-hint" *ngIf="missingFields.length">
                    <i class="fal fa-circle-exclamation"></i>
                    Falta {{ missingFields.length === 1 ? 'por indicar' : 'por indicar' }}: {{ missingFields.join(', ') }}
                </div>
                <div class="next-step-hint" *ngIf="!isEdit && !missingFields.length">
                    <i class="fal fa-circle-info"></i>
                    Al crear el abono pasarás al cobro para elegir importe y método de pago
                </div>
            </div>
        </div>
    </form>
</div>
